import Api from 'services/Api'

export const loadDefinitions = () => {
  return Api.query(`query Root {
    moments: moment_definitions {
      id
      category
      display_name
      description
    }
    segments: segment_definitions(status: ALPHA) {
      id
      category
      subcategory
      display_name
      description
    }
  }`);
};
